import React, { useEffect } from 'react'
import { ChannelAuthService } from '../../services/ChannelAuthService';
import { useLocation, useNavigate } from 'react-router';
import RedirectAnimation from "../shared/loaders/redirect-animation.json";
import AnimateLoaderComponent from '../shared/loaders/animate-loader.component';
import { AppRoutes } from '../routes/route.path';
import UnAuthComponent from '../layout/unauth.component';
import { app, authentication } from '@microsoft/teams-js';
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors'


const ChannelLoginRedirect = () => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        setTimeout(() => {

            const params = new URLSearchParams(location.search);
            const code = params.get('code');
            const error = params.get('error');
            const isTeams = localStorage.getItem("teamsUserEmail")

            if (code) {
                // Handle successful authorization
                if (!!isTeams) {
                    app.initialize().then((context) => {
                        app.notifySuccess();
                    });
                    app.getContext().then((context) => {
                        console.log("context:", context)
                        authentication.notifySuccess(code);
                    }).catch(error => {
                        console.log("error:", error)
                        authentication.notifyFailure(error.message || "An error occurred");
                    })
                }
                else if (window.location.pathname.includes("google")) {
                    ChannelAuthService.googleSignIn(code, navigate)
                        .then((res) => {
                        })
                        .catch((err) => {
                            console.log("error", err)
                            navigate(AppRoutes.CHANNELS_USER_NOT_FOUND.replace(":deletedBy", err.response.data.userStatus.admin_role !== 1 ? "org" : "sys"))
                        })
                }
                else if (window.location.pathname.includes("microsoft")) {
                    ChannelAuthService.microsoftSignIn(code, navigate).then((res) => {

                    }).catch((err) => {
                        console.log("error", err)
                        navigate(AppRoutes.CHANNELS_USER_NOT_FOUND.replace(":deletedBy", err.response.data.userStatus.admin_role !== 1 ? "org" : "sys"))
                    })
                }
                else {

                }
            } else if (error) {
                // Handle authorization error
                console.log('Authorization error:', error);
                navigate(AppRoutes.CHANNELS_SIGN_IN)
            } else {
                console.log('No authorization code or error found.');
            }
        }, 3000);

    }, [window.location])

    return (
        <div className={`d-flex flex-direction h-p-80 justify-center align-center m-auto login-background br-5  ${IsMobileDevice ? "w-p-90" : "w-p-60 bg-color-secondary"}`}>
            <div className={`d-flex align-center justify-center w-p-100 ${IsMobileDevice ? "" : "h-p-80"}`}>
                <AnimateLoaderComponent LoaderAnimation={RedirectAnimation} className={IsMobileDevice ? "" : "w-p-65"} />

            </div>
            <div className='h1-semibold d-flex justify-center h-p-20'>
                Getting things ready...!
            </div>
        </div>
    )
}


export default (UnAuthComponent(ChannelLoginRedirect));
